  <h4 class="py-2 py-sm-3 heading-4 mt-3 mb-2 top-75px page-heading">
    <span class="color-grey-700">{{mls.languageText.community.key56}}</span>
  </h4>
  
  <div class="row">
    <div class="col-md-3 col-12 mb-md-3">
      <app-create-community-card 
        class="top-125" 
        [isPastCommunity]="isPastCommunity" 
        [showNoCommunity]="showNoCommunity" 
        [setFilterAsAll]="filterKey" 
        [translations]="communityListTranslation" 
        (emitFilterKey)="viewAllhandler($event); setFilter($event)">
    </app-create-community-card>
    </div>
    
    <div class="col-md-9 col-12 pl-md-0">
      <div class="row" *ngIf="communityList.length">
        <div class="col-12 overflow-hidden pl-3">
          <span (click)="backButtonHandler()" class="cursor-pointer">
            <img src="assets/themes/icons/back-arrow.svg" alt="back icon" class="mr-2" />
            {{mls.languageText.community.key28}}
          </span>
        </div>
      </div>
      <div class="overflow-hidden" 
        infiniteScroll 
        [infiniteScrollDistance]="numbers.ONE" 
        [infiniteScrollThrottle]="numbers.ONE_THOUSAND" 
        (scrolled)="onScroll()"
        [scrollWindow]="scrollWindow.TRUE">
        <ng-container *ngFor="let communities of communityList; last as isLast">
          <app-community-card 
            [communityDetails]="communities" 
            [translations]="communityCardTranslation" 
            [isPastCommunity]="isPastCommunity"
            (emitFilterKey)="viewAllhandler($event); setFilter($event)">
            <ng-container *ngFor="let community of communities.list; last as isLast">
              <app-community-list 
                [translations]="communityListTranslation" 
                [community]="community" 
                [isLast]="isLast"
                [userId]="dss?.user_profile_data?.profile?.custom_id"
                [callingFrom]="callingFrom"
                (emitCommunityEdit)="emitCommunityEdit($event)"
                (emitCommunityDetail)="emitCommunityDetail($event)"
                (emitJoinPublicCommunity)="joinPublicCommunityHandler($event)"
                (emitWithdrawRequest)="withdrawConfirmation($event)"
                (emitReloadCommunityList)="reloadPastCommunityList($event)">
              </app-community-list>
            </ng-container>
          </app-community-card>
          <div class="separator-line" *ngIf="!isLast"></div>
        </ng-container>
      </div>
    </div>
  
    <div class="col-md-3 col-12"></div>
  </div>
  
    <app-confirm-modal
      [isWithdrawRequestConfirmModalShown]="confirmationModal"
      [confirmationModalContent]="confirmationText"
      [getListItem]="confirmedCommunity"
      (resetConfirmModal)="resetConfirmModal()"
      (emitAllowAction)="allowAction($event)">
    </app-confirm-modal>